import React from "react";
import TextArea from "@atlaskit/field-text-area";
import { HelperMessage } from "@atlaskit/form";

const RTextArea = ({ title, value, id, helperText, isCompact, width, isDisabled, minimumRows, onChange, onBlur }) => {
  return (
    <>
      {" "}
      <label htmlFor={id}>{title}</label>
      <TextArea
        name={id}
        value={value}
        isCompact={isCompact}
        width={width}
        isDisabled={isDisabled}
        minimumRows={minimumRows}
        onChange={onChange}
        onBlur={onBlur}
      />
      <HelperMessage>{helperText}</HelperMessage>
    </>
  );
};
export default RTextArea;
